import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_BASE_URL } from "./api-base";
import { DashboardData, LeaderboardRow, LearningInsight, ProfileData } from "../models/game.models";

@Injectable({ providedIn: "root" })
export class GameService {
  constructor(private readonly http: HttpClient) {}

  getDashboard() {
    return this.http.get<DashboardData>(`${API_BASE_URL}/game/dashboard`);
  }

  getLeaderboard(limit = 50, scope: "global" | "weekly" | "topic" = "global", topic?: string) {
    const topicPart = scope === "topic" && topic ? `&topic=${encodeURIComponent(topic)}` : "";
    return this.http.get<LeaderboardRow[]>(
      `${API_BASE_URL}/game/leaderboard?limit=${limit}&scope=${scope}${topicPart}`
    );
  }

  getProfile() {
    return this.http.get<ProfileData>(`${API_BASE_URL}/game/profile`);
  }

  updateProfile(payload: { name?: string; phone?: string | null; avatar?: string | null }) {
    return this.http.patch<ProfileData>(`${API_BASE_URL}/game/profile`, payload);
  }

  uploadAvatar(dataUrl: string) {
    return this.http.post<{ id: string; avatar: string }>(`${API_BASE_URL}/game/profile/avatar`, { dataUrl });
  }

  getDailyChallenge() {
    return this.http.get<{
      id: number;
      title: string;
      world: string;
      difficulty: string;
      levelNumber: number;
      xpReward: number;
    } | null>(`${API_BASE_URL}/game/daily-challenge`);
  }

  getInsights() {
    return this.http.get<LearningInsight>(`${API_BASE_URL}/game/insights`);
  }
}
